exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-container{width:100%}.slider-container input{-webkit-appearance:none;width:100%;height:3px;background:#c63e7c;outline:none}.slider-container input::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:17px;height:17px;border-radius:50%;background:#c63e7c;cursor:pointer}.slider-container input::-moz-range-thumb{width:17px;height:17px;background:#c63e7c;cursor:pointer}", ""]);

// exports
